import { useDivisionDetailQuery } from '~/pages/divisions/queries';
import { useTeamsQuery } from '~/pages/teams/queries';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';

interface Props {
  teamId: number;
  divisionId: number;
}

export function TeamRow({ teamId, divisionId }: Props) {
  const { data: team, isLoading } = useTeamsQuery(teamId);
  const { data: division } = useDivisionDetailQuery(divisionId);

  const divisionResultsPerRound = division?.results_per_round ?? 0;

  if (isLoading || !team || !division) {
    return (
      <Table.Row>
        <Table.Col colSpan={7}>{'-'}</Table.Col>
      </Table.Row>
    );
  }

  const getSeriesDisplay = (index: number) => {
    if (!division.rounds[index]) return '—';

    const divisionRound = division.rounds[index];
    const roundResult = team.round_results.find(rr => rr.round.id === divisionRound.id);

    if (!roundResult) return '—';

    const count = roundResult.results.length;
    return count > 0 ? `${count}/${divisionResultsPerRound}` : '—';
  };

  return (
    <Table.Row>
      <Table.Col>
        <Link
          to={`/series/divisions/${team.division.id}/teams/${team.id}/manage/rounds/${division?.rounds[0]?.id ?? 0}`}
        >
          {team.name}
        </Link>
      </Table.Col>
      <Table.Col>{team.division.series.name}</Table.Col>
      <Table.Col>{team.division.name}</Table.Col>
      <Table.Col>{getSeriesDisplay(0)}</Table.Col>
      <Table.Col>{getSeriesDisplay(1)}</Table.Col>
      <Table.Col>{getSeriesDisplay(2)}</Table.Col>
      <Table.Col>{getSeriesDisplay(3)}</Table.Col>
    </Table.Row>
  );
}
